import React from "react";
import { Field, ErrorMessage } from "formik";
import "./PhoneInput.scss";
import { countryCodes } from "../../../helper/countryCodes";

function PhoneInput(props) {
  const { label, isModal } = props;
  return (
    <div className="input-phone-content">
      <label htmlFor="" className="input-phone-content-label">
        {label}
      </label>
      {/* Refactorizar estos Field */}

      <div>
        <Field
          name={"phone.dial_code"}
          as="select"
          placeholder="Code"
          className={`${isModal ? "border-gray" : ""} input-phone-field-code`}
        >
          {countryCodes.map((option) => {
            return (
              <option key={option.name} value={option.dial_code}>
                {option.name} {option.dial_code}
              </option>
            );
          })}
        </Field>
        <div className="input-phone-error-field">
          <ErrorMessage name={"phone.dial_code"} />
        </div>
      </div>

      <div>
        <Field
          name={"phone.number"}
          placeholder="number"
          type="number"
          className={` ${isModal ? "border-gray" : ""} input-phone-field-number`}
        />
        <div className="input-phone-error-field">
          <ErrorMessage name={"phone.number"} />
        </div>
      </div>
    </div>
  );
}

export default PhoneInput;
